import { render, staticRenderFns } from "./cookie-contest.vue?vue&type=template&id=2a42885e&"
import script from "./cookie-contest.vue?vue&type=script&lang=js&"
export * from "./cookie-contest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports